// Enums

import type { ValueOf } from 'types/utility';

export const MEAL_VOUCHER_SUPPLIERS = {
  EDENRED: 'edenred',
  PLUXEE: 'pluxee',
} as const;

export type MealVoucherSupplier = ValueOf<typeof MEAL_VOUCHER_SUPPLIERS>;

// // Responses

export interface IMealVoucherSupplierResponse {
  enabled: boolean,
  configured: boolean,
  code: MealVoucherSupplier,
  label: string,
  icon: string,
  logo: string,
  balance?: IMealVoucherBalanceResponse,
  connectUrl: string,
  infoForNewLabel?: string
}

export interface IMealVoucherBalanceResponse {
  error: string,
  currency?: string,
  amount?: number
}

export interface IMealVoucherPaymentResponse {
  id: number,
  amount: number,
  currency: string,
  type: string
}

// Models

export interface IMealVoucherSupplier {
  meta: {
    code: MealVoucherSupplier,
    connectUrl: string,
    configured: boolean,
    enabled: boolean
  },
  details: {
    label: string,
    icon: string,
    logo: string
  },
  balance?: IMealVoucherBalanceResponse
}
